import React from 'react';

const SendAIBox = ({data}) => {
  const { answer = '', related_content = [] } = data;
  return (
    <div className="my-[5px] border rounded-[12px] border-primary px-[15px] py-[5px] max-w-[85%] w-fit">
      <div className='text-[12px] text-primary' dangerouslySetInnerHTML={{ __html: answer }}></div>
      {
        related_content.length > 0 && <div className='flex items-center justify-start flex-wrap mt-2.5'>
          {
            related_content.map((item, index) => <div key={index} className='flex flex-col justify-center w-[150px] rounded-[9px] mb-1 mr-1 bg-second p-1'>
              <video src={item.video_url} controls className='flex-1 rounded-[5px] h-[150px]'></video>
              <div className='mt-1.5 text-[12px] text-primary font-bold leading-none overflow-ellipsis overflow-hidden w-full whitespace-nowrap'>{item.title}</div>
              <div className='mt-1 mb-1 text-[12px] text-primary font-normal leading-none overflow-ellipsis overflow-hidden w-full whitespace-nowrap'>id: {item.id}</div>
              {/* <button className='mt-2.5 w-fit mx-auto border border-primary text-[12px] leading-none px-2 py-1 rounded-[20px] text-primary hover:bg-second'>Add to showreel</button> */}
            </div>)
          }
        </div>
      }
    </div>
  );
};

export default SendAIBox;